module.exports = __webpack_public_path__ + "img/logonstatus_green_blank.4177a00e.jpg";